// extracted by mini-css-extract-plugin
export default {"text":"Title_text__1dDZA","noVisible":"Title_noVisible__KMcxz"};